import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Home from './components/Home'
import About from './components/About'
import Portfolio from './components/Portfolio'
import Contact from './components/Contact'
import Sample from './components/Sample'
// import Locations from './components/Locations'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);

const routes = [
  { path: '/', component: Home },
  { path: '/About', component: About },
  { path: '/Portfolio', component: Portfolio },
  { path: '/Contact', component: Contact },
  { path: '/Sample', component: Sample },

  // { path: '/Locations', component: Locations }, 
]
const router = new VueRouter({
  routes // short for `routes: routes`
})
Vue.use(VueRouter);

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
